export default __webpack_public_path__ + "static/media/optimize-icon.f7a4b0cf.svg";